import React, {useState, useMemo} from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik"
import FormControl from '@mui/material/FormControl';
import useSafeState from '../../../../useSafeState' 
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextInput from '../../../../components/Forms/TextInput';
import ButtonForm from "../../../../components/Button/ButtonForm";
import TableComp from '../../../../components/Table/TableComp';
import Alert from "@mui/material/Alert";
import Button from '@mui/material/Button';
import { FILTER_VARIANTS } from "../../../../constants";



export function GetGeneTable() {

  const navigate = useNavigate();
  
  const [value, setValue] = useSafeState({});
  const [data, setData] = useState(useMemo(() => []));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
    
       
  const handleSubmit = (values) => {
    //const gene_input = values.gene
    setLoading(true)
    axios.get(`${FILTER_VARIANTS}/?SYMBOL=${values.gene}`)
    .then((response) => {
        const d = handleData(response.data)
        setData( d )
        setLoading(false)
        setValue({ key: 'value' }); // NO MEMORY LEAK
    })
    .catch(function (error) {
      //throw new Error(error)
      setError(error.toJSON());
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        //console.log(error.response.data, error.response.status);
        
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
        //console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        //console.log('Error', error.message);
      }
      //console.log(error.config);
      console.log("Error")
    })
  }
  
  

    const handleData = (response) => {
      let dataContainer = []
              for (let i in response) {      
                dataContainer.push(    {    'col1': response[i].id,
                                            'col2': response[i].sample,
                                            'col3': response[i].SYMBOL,
                                            'col4': response[i].Uploaded_variation,
                                            'col5': response[i].VARIANT_CLASS,
                                            'col6': response[i].Consequence,
                                            'col7': response[i].GENOTYPE,
                                            'col8': response[i].SNPS,
                                            'col9': response[i].Existing_variation,
                                            'col10': response[i].CLIN_SIG,
                                            'col11': response[i].owner,
                                      },
                                );   
              }
              return (dataContainer)
            }

  const columns = React.useMemo(
      () => [
        {
          header: 'SAMPLE',
          accessorKey: 'col2', // accessor is the "key" in the data
          cell: info => info.getValue(),
          footer: props => props.column.id,
          },
          {
            header: 'GENE',
            accessorKey: 'col3',
            cell: info => info.getValue(),
            footer: props => props.column.id,
            },
            {
              header: 'TYPE',
              accessorKey: 'col5',
              cell: info => info.getValue(),
              footer: props => props.column.id,
              },
              {
                header: 'SNPs',
                accessorKey: 'col8',
                cell: info => info.getValue(),
                footer: props => props.column.id,
                },
                {
                  header: 'CONSEQUENCE',
                  accessorKey: 'col6',
                  cell: info => info.getValue(),
                  footer: props => props.column.id,
                  },
                {
                  accessorKey: 'col10',
                  header: 'clinvar - CLASSIFICATION',
    //              header: () => <Typography component="span" variant="h6" sx={{color: "traffic.red"}}>'clinvar' CLASSIFICATION</Typography>,
                  cell: info =>  info.getValue() === 'pathogenic' ? <Typography component="span" sx={{color: "traffic.red"}}>{info.getValue()}</Typography> : info.getValue(),
                  footer: props => props.column.id,  
                },
              {
                header: 'VARIATION',
                accessorKey: 'col4',
                cell: info => info.getValue(),
                footer: props => props.column.id,
                },
                {
                  header: 'GENOTYPE',
                  accessorKey: 'col7',
                  cell: info => info.getValue(),
                  footer: props => props.column.id,
                  },
                    {
                      header: 'DB_IDs',
                      accessorKey: 'col9',
                      cell: info => info.getValue(),
                      footer: props => props.column.id,
                      },
               
      ],
      []
      )

return (
<>

<div>
<Formik
        enableReinitialize
        initialValues={{ gene: '' }}
        // validationSchema={validationRules} 
        onSubmit={(values, { setSubmitting }) => { 
            // same shape as initial values
            handleSubmit(values);
            setSubmitting(false);  
          }}
      >
     
        <Form>
        <FormControl sx={{display:'flex', justifyContent:'center', alignItems: 'center', mt:4, pb:4, }}>
           
        <TextInput label="gene" name="gene" type="text" placeholder="enter gene" bgcolor="background.default" />   
           
            <Box sx={{ '& > :not(style)': { m: 2, width: '20ch' },  }}>
               <ButtonForm name={ 'Submit' }  disabled={Formik.isSubmitting} />     
            </Box>
            
        </FormControl>
      </Form>
  </Formik>
</div>
{error  ? (
            <Alert severity="error" sx={{mt:2}}>
                <Typography variant="body2"  sx={{fontWeight: '500'}}> {error.message} </Typography>
                <Button variant="contained" onClick={() => { navigate("/", { replace: true }) }} sx={{mt:1, bgcolor: 'tertiary.dark', color:'common.white'}}> Try again </Button>
            </Alert>
            ) : (null)}



<div>
      { loading && <span> Please wait ... fetching data </span>}
      <TableComp columns={columns} data={data} />
</div>

</>

);
}